import React from 'react';
import styled from 'styled-components';

export default [
  {
    title: 'Party Name',
    render: (_, { name }) => name || '-',
    width: '25%'
  },
  {
    title: 'Segment',
    render: (_, { segment }) => segment || '-',
    width: '25%'
  },
  {
    title: 'Error Details',
    render: (_, { error }) => (
      <EllipsisBlock title={error}>{error || '-'}</EllipsisBlock>
    ),
    width: '50%'
  }
];

const EllipsisBlock = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: break-word;
  word-break: break-word;
  width: 232px;
`;
